export default __webpack_public_path__ + "static/media/ic_eth_40.1b83dd3c.svg";